import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core'
import { ParameterType } from 'src/app/interfaces/parameter'
import { ParametersService } from 'src/app/services/parameters.service'
import { DOCUMENT } from '@angular/common'
import { Subscription } from 'rxjs'
import { VirtualKeyboardService } from 'src/app/shared/components/virtual-keyboard/virtual-keyboard.service'

@Component({
  selector: 'app-self-service',
  templateUrl: './self-service.component.html',
  styleUrls: ['./self-service.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SelfServiceComponent implements OnInit, OnDestroy {
  public backgroundStyle: string = 'linear-gradient(to bottom right, #6cd8f1, #244954)'
  public backgroundType: string = 'gradient'
  public backgroundColorPrimary: string = '#6cd8f1'
  public backgroundColorSecondary: string = '#244954'
  public backgroundImageUrl: string = 'assets/images/totem/totem-background.png'
  public fontClass: string = 'roboto'
  public textFontFamily: string = 'Roboto'
  public textColor: string = '#0f0f0f'
  public parametersResponse: Array<ParameterType> = []
  public params: Array<string> = [
    'TOTEM_BACKGROUND_TYPE',
    'TOTEM_BACKGROUND_IMAGE_URL',
    'TOTEM_BACKGROUND_COLOR_PRIMARY',
    'TOTEM_BACKGROUND_COLOR_SECONDARY',
    'TEXT_FONT_FAMILY',
    'TEXT_COLOR',
    'MESSAGE_AFTER_CHECKIN',
  ]
  @ViewChild('selfServiceContainer') container: any

  elem: any
  isFullScreen = false

  private keyboardSubscription = new Subscription()

  constructor(
    private parameterService: ParametersService,
    private virtualKeyboardService: VirtualKeyboardService,
    @Inject(DOCUMENT) private document: any
  ) {
    this.elem = document.documentElement
  }

  ngOnDestroy(): void {
    this.keyboardSubscription.unsubscribe()
    this.document.documentElement.style.setProperty('--vk-height', '0px')
  }

  ngOnInit(): void {
    this.parameterService.load(this.params).subscribe(
      (response: any) => {
        this.parametersResponse = response
        this.backgroundType = this.getParameterValue('TOTEM_BACKGROUND_TYPE') || 'gradient'
        this.backgroundImageUrl =
          this.getParameterValue('TOTEM_BACKGROUND_IMAGE_URL') ||
          'assets/images/totem/totem-background.png'
        this.backgroundColorPrimary =
          this.getParameterValue('TOTEM_BACKGROUND_COLOR_PRIMARY') || '#6cd8f1'
        this.backgroundColorSecondary =
          this.getParameterValue('TOTEM_BACKGROUND_COLOR_SECONDARY') || '#244954'
        this.textFontFamily = this.getParameterValue('TEXT_FONT_FAMILY') || 'Roboto'
        this.textColor = this.getParameterValue('TEXT_COLOR') || '#0f0f0f'

        this.updateBackgroundStyle()
        this.setFontClass(this.textFontFamily)
        this.setTextColor(this.textColor)
      },
      (error) => {
        console.error('Error loading parameters', error)
      }
    )

    // listen FullScreen Subject
    this.parameterService.listenFullScreen().subscribe(() => {
      this.fullScreen()
    })

    // Publica a altura do teclado virtual como variável CSS: as telas do fluxo
    // usam --vk-height para afastar campo e botão de confirmação, garantindo que
    // o teclado nunca cubra o que o paciente está preenchendo.
    this.keyboardSubscription.add(
      this.virtualKeyboardService.height$.subscribe((height: number) => {
        this.document.documentElement.style.setProperty('--vk-height', `${height}px`)
      })
    )
  }

  private getParameterValue(key: string): string | undefined {
    const param = this.parametersResponse.find((param: any) => param.chave === key)
    return param ? param.valor : undefined
  }

  updateBackgroundStyle(): void {
    switch (this.backgroundType) {
      case 'image':
        this.backgroundStyle = `url(${this.backgroundImageUrl})`
        break
      case 'color':
        // Gradient with the same color on primary and secondary colors, is the color
        this.backgroundStyle = `linear-gradient(to bottom right, ${this.backgroundColorPrimary}, ${this.backgroundColorPrimary})`
        break
      case 'gradient':
        this.backgroundStyle = `linear-gradient(to bottom right, ${this.backgroundColorPrimary}, ${this.backgroundColorSecondary})`
        break
      default:
        this.backgroundStyle = `linear-gradient(to bottom right, ${this.backgroundColorPrimary}, ${this.backgroundColorPrimary})`
    }
  }

  setFontClass(textFontFamily: string) {
    this.fontClass = `font-${textFontFamily.toLowerCase().replace(/\s+/g, '-')}`
  }

  setTextColor(textColor: string) {
    // Aplica a variável CSS global
    document.documentElement.style.setProperty('--text-color', textColor)

    // Seleciona todos os elementos de texto relevantes
    const elementsToStyle = document.querySelectorAll(`
      .title,
      .setting-title,
      mat-label,
      .mat-select-value-text,
      .mat-option-text,
      button,
      h2,
      h3,
      p,
      span,
      div
    `)

    // Aplica a cor para cada elemento
    elementsToStyle.forEach((element: any) => {
      element.style.color = textColor
    })

    // Aplica estilos específicos para elementos do Material
    const matFormFields = document.querySelectorAll('.mat-form-field')
    matFormFields.forEach((field: any) => {
      // field.querySelector('.mat-form-field-label').style.color = textColor;
      // field.querySelector('.mat-select-arrow').style.color = textColor;
    })
  }
  fullScreen(): void {
    if (this.isFullScreen === true) {
      this.isFullScreen = false

      if (this.document.exitFullscreen) {
        this.document.exitFullscreen()
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen()
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen()
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen()
      }
    } else {
      this.isFullScreen = true

      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen()
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen()
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen()
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen()
      }
    }
  }
}
